import {api2Endpoint} from 'app/config/apiConfig'
import {useMutation} from 'react-query'
import {postData} from '../api/usePostData'
import {announceReturn, announceSend} from '../api/utils/announce'
import errorNotify from '../api/utils/errorNotify'

interface Args {
  user_id: string
  user_email: string
  graph_entity_type?: string
  notify_entity_type?: string
}

export function useRunNotifySearch(errMsg = 'Failed to run search') {
  return useMutation(async (args: Args) => {
    try {
      const route = `internal/notify/${args.user_id}/${args.graph_entity_type}/${args.notify_entity_type}`
      announceSend('post', route)
      const retval = await postData<any>(api2Endpoint(route), {user_email: args.user_email})
      announceReturn('post', route)
      return retval
    } catch (err) {
      errorNotify(err, errMsg)
    }
  })
}
